import {
	UnlockUser,
	DataRoomUser,
	DataRoomTeamMember,
	DealPartnerContact,
	MilestoneReport,
	TeamMember,
	FacilityTypes,
	AssociatedTeamMember,
} from '../models';

export function GetUnlockUserFromDealPartnerContact(contact: DealPartnerContact | null): UnlockUser | null {
	if (contact == null) return null;
	return {
		guid: contact.guid,
		firstName: contact.firstName,
		lastName: contact.lastName,
		emailAddress: contact.emailAddress,
		organization: contact.dealPartnerName,
		roleType: 'DealPartnerUser',
		userGuid: contact.userGuid,
	} as UnlockUser;
}

export function GetUnlockUserFromDataRoomUser(user: DataRoomUser | null): UnlockUser | null {
	if (user == null) return null;

	return {
		guid: user.guid,
		firstName: user.firstName,
		lastName: user.lastName,
		emailAddress: user.emailAddress,
		organization: user.bankName,
		roleType: 'BankUser',
		userGuid: user.userGuid,
	} as UnlockUser;
}

export function GetUnlockUserFromAssociatedTeamMember(
	member: AssociatedTeamMember | null,
	user: DataRoomUser | null
): UnlockUser | null {
	if (member == null || user == null) return null;

	return {
		guid: member.guid,
		firstName: member.firstName,
		lastName: member.lastName,
		emailAddress: member.emailAddress,
		organization: user.bankName,
		roleType: GetRoleTypeFromAssociatedTeamMember(member),
		userGuid: member.userGuid,
	} as UnlockUser;
}

function GetRoleTypeFromAssociatedTeamMember(
	member: AssociatedTeamMember | null
): 'DataRoomUser' | 'TeamMemberUser' | null {
	if (member == null) {
		return null;
	}
	if (member.contactType === 'DataRoomUser') {
		return 'DataRoomUser';
	}
	if (member.contactType === 'TeamMember') {
		return 'TeamMemberUser';
	}
	return null;
}

export function GetUnlockUserFromTeamMember(
	member: DataRoomTeamMember | null,
	user: DataRoomUser | null
): UnlockUser | null {
	if (member == null || user == null) return null;

	return {
		guid: member.guid,
		firstName: member.firstName,
		lastName: member.lastName,
		emailAddress: member.emailAddress,
		organization: user.bankName,
		roleType: 'TeamMemberUser',
		userGuid: member.userGuid,
	} as UnlockUser;
}

export function GetUnlockUserFromMilestoneReport(report: MilestoneReport | null): UnlockUser | null {
	if (report == null) return null;

	return {
		guid: report.guid,
		firstName: report.firstName,
		lastName: report.lastName,
		emailAddress: report.emailAddress,
		organization: report.bankName,
		roleType: 'BankUser',
		userGuid: report.userGuid,
	} as UnlockUser;
}

export function GetDataRoomUserFromMilestoneReport(report: MilestoneReport | null): DataRoomUser | null {
	if (report == null) return null;

	return {
		id: report.id,
		guid: report.guid,
		bankId: report.bankId,
		bankGuid: report.bankGuid,
		bankName: report.bankName,
		dataRoomId: report.dataRoomId,
		dataRoomGuid: report.dataRoomGuid,
		bankDealProfileId: report.bankDealProfileId,
		bankDealProfileGuid: report.bankDealProfileGuid,
		personId: report.personId,
		userId: report.userId,
		userGuid: report.userGuid,
		firstName: report.firstName,
		lastName: report.lastName,
		emailAddress: report.emailAddress,
		phone: report.phone,
		tier1: report.tier1Type,
		structureTranche: report.structureTranche,
		dealBankStatus: report.dealBankStatus,
		noteCount: report.noteCount,
		optedOut: report.optedOut,
		isLockedOut: report.isLockedOut,
		allowAccess: report.allowAccess,
		tier3ContactType: report.tier3ContactType,
		tier3ContactTypeDescription: report.tier3ContactTypeDescription,
		signedNda: report.signedNda,
		teamMembers: [] as AssociatedTeamMember[],
	} as DataRoomUser;
}

export function isEither(type: FacilityTypes | undefined): boolean {
	return isRevolverFacilityType(type) || isTermLoan(type);
}

export function isRevolverFacilityType(type: FacilityTypes | undefined): boolean {
	return type != undefined && (type == 'Revolver' || type == 'Line_of_Credit');
}

export function isLeaseFacilityType(type: FacilityTypes | undefined): boolean {
	return type != undefined && (type == 'CapitalLease' || type == 'EquipmentLease' || type == 'OperatingLease');
}

export function isTermLoan(type: FacilityTypes | undefined): boolean {
	return type != undefined && !isRevolverFacilityType(type) && !isLeaseFacilityType(type);
}

export function isFactorPO(type: FacilityTypes | undefined): boolean {
	return type == 'PurchaseOrderFinancing' || type == 'Factor';
}
